import { CURRENCY_CODE_PLACEHOLDER, VALUE_PLACEHOLDER, currencyFormatConfig, defaultCurrencyFormatConfig, getCurrencyFormat, } from './currency-format-config';
export const isWholeNumber = (value) => Math.floor(value) === value;
export const getCurrencyFormatConfig = (currencyCode) => 
// @ts-expect-error
currencyFormatConfig[currencyCode] || defaultCurrencyFormatConfig;
export const getFormattedPriceValue = (value, currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return value.toFixed(!isWholeNumber(value) ? config.decimalDigits : 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
/** @deprecated use priceFormatter */
export const getFormattedPrice = (value, currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return getCurrencyFormat(config)
        .replace(VALUE_PLACEHOLDER, getFormattedPriceValue(value, currencyCode))
        .replace(CURRENCY_CODE_PLACEHOLDER, currencyCode);
};
/** @deprecated use priceFormatter */
export const getFormattedMoney = (money) => getFormattedPrice(Number(money.amount ?? 0), money.currency);
export const getFormattedDiscount = (discount) => isWholeNumber(discount) ? Math.trunc(discount) : discount;
export const getCurrencySymbol = (currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return config.symbol || currencyCode;
};
export const isCurrencySuffixed = (currencyCode) => {
    const config = getCurrencyFormatConfig(currencyCode);
    return config.suffix || false;
};
//# sourceMappingURL=formatter.js.map